import { React, useState, useRef, useCallback, useContext, useEffect } from 'react';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { AppContext } from '../../../context/ContextProvider';
import styled from 'styled-components';
import Select, { SelectOption } from '@iso/components/uielements/select';
import initialData from '../../../redux/scrumBoard/data';
import { AlertContext } from '../../../context/alertContext';
import gcpIcon from '@iso/assets/images/icon/gcp-logo.svg';
import api from '../../../api';
import { formatErrors } from '../../../context/helper';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Form, Spin, Tooltip } from 'antd';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';

const Option = SelectOption;

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const initialErrors = {
  status: false,
  content: {},
};

const permissionColumns = [
  { key: "create_repository", label: "Create Repo" },
  { key: "push_image", label: "Push" },
  { key: "list_images", label: "List" },
  { key: "pull_image", label: "Pull" },
  { key: "get_image", label: "Get Image" },
  { key: "delete_repository", label: "Delete Repo" }
];

const permissionTooltips = {
  create_repository: "Grant container.repositories.create for this credential.",
  push_image: "Grant storage.objects.create to allow pushing images.",
  list_images: "Grant container.images.list so repositories can list images.",
  pull_image: "Grant storage.objects.get for pulling images.",
  get_image: "Grant container.images.get (image metadata).",
  delete_repository: "Grant container.repositories.delete to delete repositories."
};

export default function GcrIntgration({
    // handleSubmit,
    data,
    load,
    setLoad,
    connected,
    setConnected,
    onCancel,
    onDelete,
    openDrawer,
    onEditCancel,
    tabSelected,
    openAddOns
}) {

    const { setOpenRightDrawer } = useContext(AppContext);
    const { set_alertOptions } = useContext(AlertContext);

    const [gcrData, setGcrData] = useState({
        selectionType: "account_id", // "account_id" or "credentials"
        accountId: [],
        region: [],
        credentialId: null
    });

    const [allAccountIds, setAllAccountIds] = useState([]);
    const [allRegions, setAllRegions] = useState([]);
    const [allCredentials, setAllCredentials] = useState([]);
    const [isValidated, setIsValidated] = useState(false);
    const [validating, setValidating] = useState(false);
    const [connecting, setConnecting] = useState(false);

    const [error, setError] = useState({ ...initialErrors });

    const [form] = Form.useForm();
    const abortControllersRef = useRef(new Set());

    const registerAbortController = () => {
        const controller = new AbortController();
        abortControllersRef.current.add(controller);
        return controller;
    };

    const unregisterAbortController = (controller) => {
        if (controller) {
            abortControllersRef.current.delete(controller);
        }
    };

    const abortAllPendingRequests = useCallback(() => {
        abortControllersRef.current.forEach((controller) => controller.abort());
        abortControllersRef.current.clear();
    }, []);

    useEffect(() => {
        console.log("data :", data);
        console.log("initialData :", initialData);
        let accountIds = [];
        let regions = [];
        // accountIds
        data?.forEach((temp) => {
            if (temp.integration_type === "gcp" && temp.status) {
                accountIds.push(
                    <Option key={temp.account_id} name="accountId" data-alias={temp.alias} type={temp.integration_type} value={temp.account_id}>
                        <div name="accountId" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                            <img src={gcpIcon} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                            <span name="accountId">{`${temp.account_id}${temp.alias ? ` (${temp.alias})` : ""}`}</span>
                        </div>
                    </Option>
                );
            }
        });

        // Integrate New Account on no gcp account found
        // if (accountIds.length >= 0) {
        //     accountIds.push(
        //         <Option key={data.length} name="accountId" data-alias="" type="integration" style={{ color: "white", background: "#1677ff" }}>
        //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
        //                 <span>Integrate New Account</span>
        //             </div>
        //         </Option>
        //     );
        // }

        // regions
        Object.keys(initialData.regions["gcp"]).forEach((child, ind) => {
            regions.push(<Option key={child + "-" + ind} name="region" value={child}>
                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%" }}>
                    <span>{`${initialData.regions["gcp"][child].name} / ${child}`}</span>
                </div>
            </Option>);
        });

        setAllAccountIds([...accountIds]);
        setAllRegions([...regions]);

        // Set initial form values
        form.setFieldsValue({
            selectionType: "account_id",
            accountId: [],
            region: [],
            credentialId: null
        });

        fetchCredentialsList();
    }, []);

    useEffect(() => {
        return () => {
            abortAllPendingRequests();
        };
    }, [abortAllPendingRequests]);

    const toggleAlert = (type, message, description) => {
        set_alertOptions({
            status: true,
            type: type,
            message: message,
            description: description
        });
        setTimeout(() => {
            set_alertOptions(prev => ({ ...prev, status: false }));
        }, 5000);
    };

    const fetchCredentialsList = async () => {
        const controller = registerAbortController();
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URI}/api/admin/credentials/create/`, {
                signal: controller.signal,
            });
            if (response.data.status && response.data.data.results) {
                let credentials = [];
                response.data.data.results.forEach((cred) => {
                    if (cred.provider?.toLowerCase() === "gcp" && cred.status?.toLowerCase() === "active") {
                        const accountId = cred.configuration?.project_id || "";
                        credentials.push(
                            <Option key={cred.id} name="credentialId" value={cred.id} data-accountid={accountId} data-region={cred.configuration?.region}>
                                <div name="credentialId" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <img src={gcpIcon} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                                    <span name="credentialId">{`${cred.name}${accountId ? ` (${accountId})` : ""}`}</span>
                                </div>
                            </Option>
                        );
                    }
                });
                setAllCredentials([...credentials]);
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log('Credentials request canceled.');
                return;
            }
            console.log('Error fetching credentials:', err);
            toggleAlert("error", "Failed", "Failed to fetch credentials list.");
        } finally {
            unregisterAbortController(controller);
        }
    };

    const handleClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: ""
            },
        });
    }

    const handleSelectChange = (value, event) => {
        const eventArray = Array.isArray(event) ? event : [event];
        const eventName = eventArray[0]?.props?.name || eventArray[0]?.name;

        if (eventName === "redirect") {
            return;
        }

        if (eventName === "selectionType") {
            setGcrData({
                selectionType: value,
                accountId: [],
                region: [],
                credentialId: null
            });

            form.setFieldsValue({
                selectionType: value,
                accountId: [],
                region: [],
                credentialId: null
            });

            setIsValidated(false);
            setError({ status: false, content: {} });
            return;
        }

        if (eventName === "credentialId") {
            setGcrData({ ...gcrData, credentialId: value });
            form.setFieldsValue({ ...gcrData, credentialId: value });
            setError({ status: false, content: {} });
            setIsValidated(false);
            return;
        }

        if (eventName === "accountId") {
            setGcrData({ ...gcrData, accountId: value });
            form.setFieldsValue({ ...gcrData, accountId: value });
            setIsValidated(false);
            setError({ status: false, content: {} });
            return;
        }

        if (eventName === "region") {
            setGcrData({ ...gcrData, region: value });
            form.setFieldsValue({ ...gcrData, region: value });
            setIsValidated(false);
            return;
        }
    };

    const handleValidate = async (arg) => {
        const isSaveFlow = typeof arg === 'boolean' ? arg : false;
        let controller = null;
        try {
            setValidating(true);

            if (gcrData.selectionType === "credentials") {
                await form.validateFields(['credentialId', 'region']);

                const payload = {
                    credential_id: gcrData.credentialId,
                    integration_type: "gcr",
                    regions: gcrData.region,
                };

                controller = registerAbortController();
                const response = await api.post(
                    `${process.env.REACT_APP_API_URI}/api/admin/credentials/validate-credentials/`,
                    payload,
                    { signal: controller.signal }
                );

                if (response.data.status) {
                    if (response.data.data?.validation_status?.toLowerCase() === "success") {
                        if (!isSaveFlow) setIsValidated(true);
                        setError({ status: false, content: {} });
                        toggleAlert("success", "Success", `Credentials validated successfully. ${isSaveFlow ? "Please wait for the integration to complete." : ""}`);
                        return true;
                    }
                    else if (response.data.data?.validation_status?.toLowerCase() === "failed") {
                        if (response.data.data.permissions) {
                            setError({
                                status: true,
                                msg: response.data.data.message,
                                content: {
                                    ...response.data.data.permissions
                                },
                            });
                        }

                        let err = formatErrors(response.data.data.message);
                        toggleAlert("error", "Validation/Permission Failed", err);
                        return false;
                    }
                } else {
                    let err = formatErrors(response.data.error_details);
                    toggleAlert("error", "Validation Failed", err);
                    setError({ status: false, content: {} });
                    return false;
                }
            } else {
                await form.validateFields(['accountId', 'region']);
                if (!isSaveFlow) setIsValidated(true);
                setError({ status: false, content: {} });
                return true;
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log("Validation request canceled.");
                return false;
            }
            if (err?.errorFields) {
                return false;
            }
            console.log("Validation error:", err);
            setError({ status: false, content: {} });
            return false;
        } finally {
            if (controller) {
                unregisterAbortController(controller);
            }
            setValidating(false);
        }
    };

    const handleValidateAndSave = async () => {
        const validationSuccess = await handleValidate(true);
        if (validationSuccess) {
            await handleIntegration();
        }
    };


    const handleIntegration = async (e) => {
        try {
            await form.validateFields();
        }
        catch (err) {
            console.log("Error", err);
            return;
        }

        setConnecting(true);
        setLoad((prev) => ({ ...prev, gcr: true }));
        let payload;

        if (gcrData.selectionType === "credentials") {
            payload = {
                credential_id: gcrData.credentialId,
                regions: gcrData.region,
            };
        } else {
            payload = {
                project_ids: gcrData.accountId,
                regions: gcrData.region,
            };
        }

        try {
            const res = await api.post(
                process.env.REACT_APP_API_URI + '/api/integration/gcr-credentials/',
                payload,
            );
            let data = res.data;
            if (data.status) {
                setConnected((prev) => !prev);
                toggleAlert("success", "Success", "GCR Account Connected Successfully.");
            }
            else {
                let err = formatErrors(data.error_details);
                toggleAlert("error", "Failed", err);
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log('Integration request canceled.');
                return;
            }
            toggleAlert("error", "Failed", "Something went wrong");
            console.log('Error in gcr integration :', err);
        } finally {
            setConnecting(false);
            setLoad((prev) => ({ ...prev, gcr: false }));
            handleClick();
        }
    };

    const handleCancel = () => {
        abortAllPendingRequests();
        setValidating(false);
        setConnecting(false);
        setLoad((prev) => ({ ...prev, gcr: false }));
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    };

    return (
        <ProdContentHold>
            <CreateTaskHeader
                buttonContent="GCR"
                data={"Yes"}
                onCancel={handleCancel}
                onDelete={onDelete}
                onEditCancel={handleCancel}
            />

            <Form
                form={form}
                name="gcrForms"
                initialValues={gcrData}
            >
                {(validating || connecting) && (
                    <LoaderOverlay>
                        <Spin size="large" />
                    </LoaderOverlay>
                )}

                {/* <Box
                    title={<div style={{ display: "flex", marginTop: "100px" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Integration Type :</span></div>}
                >
                    <ContentHolder>
                        <Form.Item
                            name="selectionType"
                            initialValue={gcrData.selectionType}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select integration type."
                                }
                            ]}
                        >
                            <Select
                                name="selectionType"
                                style={{ width: '100%' }}
                                placeholder="Select type"
                                onChange={handleSelectChange}
                                disabled={validating}
                            >
                                <Option key="account_id" name="selectionType" value="account_id">
                                    Cloud Accounts
                                </Option>
                                <Option key="credentials" name="selectionType" value="credentials">
                                    Credentials
                                </Option>
                            </Select>
                        </Form.Item>
                    </ContentHolder>
                </Box> */}

                {gcrData.selectionType === "account_id" && (
                    <Box
                        title={<div style={{ display: "flex", marginTop: "100px" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Project ID :</span></div>}
                    >
                        <ContentHolder>
                            {console.log("allAccountIds :", allAccountIds)}
                            <Form.Item
                                name="accountId"
                                rules={[
                                    {
                                        required: gcrData.selectionType === "account_id",
                                        message: "Please select Project ID."
                                    }
                                ]}
                            >
                                <Select
                                    mode={allAccountIds.length > 0 ? "multiple" : "single"}
                                    name="accountId"
                                    style={{ width: '100%' }}
                                    placeholder="Select project Ids"
                                    onChange={handleSelectChange}
                                    disabled={validating}
                                >
                                    {allAccountIds.length > 0 ? allAccountIds :
                                        <Option key="0" name="redirect" data-alias="" type="integration" style={{ color: "white", background: "#1677ff" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                                <span>No GCP account integration found. Integrate a new account.</span>
                                            </div>
                                        </Option>
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                )}

                {gcrData.selectionType === "credentials" && (
                    <Box
                        title={<div style={{ display: "flex" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Credentials :</span></div>}
                    >
                        <ContentHolder>
                            <Form.Item
                                name="credentialId"
                                rules={[
                                    {
                                        required: gcrData.selectionType === "credentials",
                                        message: "Please select a credential."
                                    }
                                ]}
                            >
                                <Select
                                    name="credentialId"
                                    style={{ width: '100%' }}
                                    placeholder="Select credential"
                                    onChange={handleSelectChange}
                                    disabled={validating}
                                >
                                    {allCredentials.length > 0 ? allCredentials :
                                        <Option key="no-creds" disabled>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <span>No active GCP credentials found.</span>
                                            </div>
                                        </Option>
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                )}

                <Box
                    title={<div style={{ display: "flex" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Region :</span></div>}
                    style={{ marginBottom: (error.status && !validating) ? "0px" : "150px" }}
                >
                    <ContentHolder>
                        <Form.Item
                            name="region"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select region."
                                }
                            ]}
                        >
                            <Select
                                mode="multiple"
                                name="region"
                                style={{ width: '100%' }}
                                placeholder="Select regions"
                                onChange={handleSelectChange}
                                disabled={validating}
                            >
                                {allRegions}
                            </Select>
                        </Form.Item>
                    </ContentHolder>
                </Box>

                {error.status && !validating && (
                    <Box style={{ marginBottom: "150px" }}>
                        <ContentHolder style={{ marginTop: "0px" }}>
                            <span style={{ fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "500", color: "#d20a0a" }}>*{error.msg}</span>

                            {permissionColumns.length > 0 && Object.keys(error.content).length > 0 && <div style={{ overflowX: "auto" }}>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        fontFamily: "'Nunito Sans', sans-serif",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #e5e5e5", fontWeight: 600, color: "#132f44" }}>
                                                Region
                                            </th>
                                            {permissionColumns.map((column) => (
                                                <th
                                                    key={`head-${column.key}`}
                                                    style={{ textAlign: "center", padding: "12px 16px", borderBottom: "1px solid #e5e5e5", fontWeight: 600, color: "#132f44" }}
                                                >
                                                    {column.label}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(error.content).map((region) => (
                                            <tr key={region}>
                                                <td style={{ padding: "12px 16px", borderBottom: "1px solid #f0f0f0", fontWeight: 500 }}>
                                                    {region}
                                                </td>
                                                {permissionColumns.map((column) => {
                                                    const permissionStatus = error.content[region]?.[column.key];
                                                    const isSuccess = permissionStatus === true;
                                                    const isFailure = permissionStatus === false;
                                                    const tooltipText = permissionTooltips[column.key] || "IAM policy missing for this permission.";
                                                    return (
                                                        <td
                                                            key={`${region}-${column.key}`}
                                                            style={{ padding: "12px 16px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}
                                                        >
                                                            {(isSuccess || isFailure) ? (
                                                                isSuccess ? (
                                                                    <CheckCircleFilled style={{ fontSize: 18, color: "#0f9d58" }} />
                                                                ) : (
                                                                    <Tooltip title={tooltipText} placement="top">
                                                                        <CloseCircleFilled style={{ fontSize: 18, color: "#d20a0a", cursor: "help" }} />
                                                                    </Tooltip>
                                                                )
                                                            ) : (
                                                                <span style={{ color: "#999999" }}>—</span>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>}
                        </ContentHolder>
                    </Box>
                )}
            </Form>

            <CreateTaskFooter buttonContent={"gcr"} givenButtonFunction1={handleValidate} givenButtonFunction2={handleIntegration} givenButtonFunction3={handleValidateAndSave} disabled={validating || connecting} isValidated={isValidated} showOnlyConnectButton={gcrData.selectionType === "account_id" ? true : false} />
        </ProdContentHold>
    );
};
